export default __webpack_public_path__ + "static/media/offer-2.6a68d06c.jpg";